import React, { useState, useEffect } from "react";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import { PlusCircleIcon, PencilIcon, TrashIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import Layout from "./../../components/Layout/Layout";
import NewsServices from "./../../services/NewsServices";
import { convert, formatDate } from "./../../utils/convertDate";
import Paginate from "./../../utils/Paginate";
import DatePicker from "react-date-picker";

export default function AllPosts() {
    const [news, setNews] = useState([])
    const [content, setContent] = useState("");
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false)
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("")
    const [status, setStatus] = useState("");
    const [target, setTarget] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));

    const list = async () => {
        const resp = await NewsServices.listPromotion(pageIndex, 10, search, fromm, too, status, target);
        if (resp) {
            setNews([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setContent([...resp.data.result]);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
        }
    }

 

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

        const resp = await NewsServices.listPromotion(pageIndex, 10, search, convert(newDate), convert(toDate), status, target);
        if (resp) {
            setNews([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setContent([...resp.data.result]);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
        }
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
        
    };
    const handleStatus = async (text) => {
        if (text === "All") {
            const resp = await NewsServices.listPromotion(pageIndex, 10, search, fromm, too, "", target);
        if (resp) {
            setNews([...resp.data.result]);
            setContent([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
        }
        }else{
            setStatus(text);
            const resp = await NewsServices.listPromotion(pageIndex, 10, search, fromm, too, text, target);
            if (resp) {
                setNews([...resp.data.result]);
                setContent([...resp.data.result]);
                setPageLength([...resp.data.result].length);
                setPageNumber(resp.data.totalCount)
                setPageIndex(resp.data.pageIndex)
                setPrev(resp.data.hasPreviousPage);
                setPage(resp.data.totalPages);
                setNextPage(resp.data.hasNextPage);
            }
        }
        
    }
    const handleType = async (types) => {
        if (types === "All") {
            const resp = await NewsServices.listPromotion(pageIndex, 10, search, fromm, too, status, '');
            if (resp) {
                setNews([...resp.data.result])
                setContent([...resp.data.result])
                setPageLength([...resp.data.result].length);
                setPageNumber(resp.data.totalCount)
                setPageIndex(resp.data.pageIndex)
                setPrev(resp.data.hasPreviousPage);
                setPage(resp.data.totalPages);
                setNextPage(resp.data.hasNextPage);
            }
            return;
        }
        setTarget(types);
        const resp = await NewsServices.listPromotion(pageIndex, 10, search, fromm, too, status, types);
        if (resp) {
            setNews([...resp.data.result])
            setContent([...resp.data.result])
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
        }
    }
    const searchPost = async (text) => {
           setSearch(text);
    }
    const htmlString = (text) => {
        if (text !== null) {
            var plainString = text.replace(/<[^>]+>/g, '');
            return plainString;
        }
       
    }


    useEffect(() => {
        list();
    }, [pageIndex, ])
    return (<>
        <Layout title="All News Feed" pageTag={'news'} current={'/posts'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="mt-4 sm:mt-0 sm:ml-6 flex justify-end">
                            <Link to="/promotion">
                                <button
                                    type="button"
                                    className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                >
                                    <PlusCircleIcon className="w-4 mr-1.5" />
                                    Create New Feed
                                </button>
                            </Link>
                        </div>
                        <div className='py-4'>
                            <div className="px-4 ">
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">
                                     
                                        <div className="relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>From</p>
                                            <div>
                                                <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                            </div>
                                        </div>
                                        <div className=" relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>To</p>
                                            <div>
                                                <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                            </div>
                                        </div>
                                        <div className="mt-5 ml-3 relative rounded-md shadow-sm">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </div>
                                            <input
                                                type="text"
                                                name="user"
                                                onChange={(e) => searchPost(e.target.value)}
                                                id="user"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                                placeholder="Search"
                                            />
                                            <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                            <div className='tooltip'>
                                                <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                <span className="tooltiptext"> <p>Search by content and title</p></span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className='mt-5 ml-4'>
                                            <button
                                                onClick={range}
                                                className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                        </div>
                                        <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                            <select
                                                id="currency"
                                                name="currency"
                                                onChange={(e) => handleType(e.target.value)}
                                                placeholder="Sort by"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                            >
                                                <option>Sort by</option>
                                                <option value={"All"}>All</option>
                                                <option value={"Specific"}>Specific</option>
                                            </select>
                                        </div>
                                        <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                            <select
                                                id="currency"
                                                name="currency"
                                                onChange={(e) => handleStatus(e.target.value)}
                                                placeholder="Sort by"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                            >
                                                <option>Filter by</option>
                                                <option value={"QUEUED"}>Queued</option>
                                                <option value={"DISPACTHED"}>Dispacthed</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                {news.length === 0 ? (
                                    <div className=" mt-8"> No data available for these dates to show. </div>
                                ) : 
                                <>
                                <div className="mt-8 flex flex-col">
                                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div className="inline-block min-w-full py-2 align-middle ">
                                            <div className="relative overflow-hidden  ring-black ring-opacity-5 md:rounded-lg">
                                                <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                                                    {news.map((person, i) => (
                                                        <li
                                                            key={i}
                                                            className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
                                                        >
                                                            <div className="flex-1 flex flex-col p-2">
                                                                <img src={person.imageUrl} alt="" />
                                                                <h3 className="text-gray-900 text-sm font-medium text-left mt-3 font-black">{person.title}</h3>
                                                                <h2 className='text-black'>{htmlString(person.content)}</h2>
                                                                <div className="flex py-4">
                                                                    <div className="flex-shrink-0 mr-3 rounded-xl bg-black h-6 w-6" ><p className='text-white text-center uppercase'>{person.createdBy.charAt(0)}</p>
                                                                    </div>
                                                                    <div className="mr-2 text-left">
                                                                        <h3 className=" leading-3 text-gray-900 text-sm font-medium">{person.createdBy}</h3>
                                                                        <p className='text-xs text-left'>{formatDate(person.dateCreated)}</p>
                                                                    </div>

                                                                    <div>
                                                                        <TrashIcon className="w-4" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                            </>}
                             

                            </div>

                        </div>
                    </div>
                </main>

            </React.Fragment>
        </Layout>

    </>);
}
